var exports = {
  "Rq": "MfaTotpEnableModal.module__qrContainer___VU1SYl",
  "JB": "MfaTotpEnableModal.module__qrCode___VU1SYl",
  "DM": "MfaTotpEnableModal.module__instructionsContainer___VU1SYl",
  "u_": "MfaTotpEnableModal.module__setupDescription___VU1SYl",
  "sO": "MfaTotpEnableModal.module__secretBlock___VU1SYl",
  "tx": "MfaTotpEnableModal.module__secretRow___VU1SYl",
  "iO": "MfaTotpEnableModal.module__secretLabel___VU1SYl",
  "yD": "MfaTotpEnableModal.module__secretText___VU1SYl",
  "iA": "MfaTotpEnableModal.module__buttonIcon___VU1SYl",
};

module.exports = exports;
